import a from '../../images/a.webp'
import logo1 from '../../images/logo1.png'
import logo2 from '../../images/logo2.png'
import logo3 from '../../images/logo3.jpg'
import e from '../../images/e.webp'
import b from '../../images/b.webp'
import c from '../../images/c.webp'
import d from '../../images/d.webp'
import f from '../../images/f.webp'
import g from '../../images/g.webp'
import h from '../../images/h.webp'
import i from '../../images/i.png'
import j from '../../images/j.png'
import k from '../../images/k.webp'
import l from '../../images/l.jpg'
import m from '../../images/m.webp'
import n from '../../images/teams/2055x_team.webp'

const imageMap = {
a,
logo1,
logo2,
logo3,
e,
b,
c,
d,
f,
g,
h,
i,
j,
k,
l,
m,
n,
}

const items = [
    {
        title: "Brampton Robotics VRC Qualifier and Skills",
        location: "Brampton ON",
        date: "January 23rd, 2023 - Brampton ON",
        imgKey: "",
        description: "Awards:",
        award1: "   - Tournament Finalists (2055A + B)",
        award2: "   - Judges Award (2055B)"
    },
    {
        title: "Canadian Open VRC Signature Event",
        location: "Markham ON",
        date: "Febuary 12th, 2023 - Markham ON",
        imgKey: "",
        description: "Awards:",
        award1: "   - Design Award (2055A)",
        award2: "   - Excellence Award (2055B)"
    },
    {
        title: "Brampton Robotics VRC Qualifier and Skills, Judging",
        location: "Brampton ON",
        date: "Febuary 18th, 2023 - Brampton ON",
        imgKey: "logo1",
        description: "Awards:",
        award1: "   - Tournament Semifinalists (2055B)",
        award2: "   - Judges Award (2055B)"
    },
    {
        title: "iDESIGN Central Toronto VEX Robotics Competition",
        location: "Toronto ON",
        date: "Febuary 25th, 2023 - Toronto ON",
        imgKey: "",
        description: "Awards:",
        award1: "   - Robot Skills Champion (2055B)",
        award2: "   - Build Award (2055B)",
        award3: "   - Tournament Champions (2055B)"
    },
    {
        title: "VEX Robotics Ontario VRC Provincial Championships 2023 (Remote Judging & Engineering Book Submission - 2055B)",
        location: "Niagara Falls ON",
        date: "March 5th, 2023 - Niagara Falls ON",
        imgKey: "",
        description: "Awards:",
        award1: "   - Innovate Award (2055A)",
        award2: "   - Judges Award (2055B)"
    },
    {
        title: "2023 VEX Robotics World Championship",
        location: "Dallas TX",
        date: "April 27-30th, 2023 - Dallas TX",
        imgKey: "",
        description: "Awards:",
        award1: "   - Division Champions (2055B)",
        award2: "   - Design Award (2055B)"
    },
    {
        title: "VRC Over/Under Qualifier + Remote Judging and Notebooks",
        location: "Brampton ON",
        date: "November 23rd, 2023 - Brampton ON",
        imgKey: "h",
        description: "Awards:",
        award1: "   - Tournament Champions",
        award2: "   - Think Award"
    },
    {
        title: "St. Catharines VRC Qualifier",
        location: "St. Catharines ON",
        date: "December 2nd, 2023 - St. Catharines ON",
        imgKey: "logo3",
        description: "Awards:",
        award1: "   - Tournament Finalists (2055X)",
        award2: "   - Think Award (2055X)"
    },
    {
        title: "VRC Over/Under Qualifier + Remote Judging and Notebooks",
        location: "Brampton ON",
        date: "December 16th, 2023 - Brampton ON",
        imgKey: "logo2",
        description: "Awards:",
        award1: "   - Excellence Award (2055A)"
    },
    {
        title: "Hollywood Blockbuster VRC Signature Event",
        location: "Los Angeles CA",
        date: "December 27-29th, 2023 - Los Angeles CA",
        imgKey: "g",
        description: "Awards:",
        award1: "   - Sportsmanship Award (2055A)"
    },
    {
        title: "Canadian Open VRC Signature Event",
        location: "Markham ON",
        date: "January 27-28th, 2024 - Markham ON",
        imgKey: "a",
        description: "Awards:",
        award1: "   - Think Award (2055A)"
    }, 
    {
        title: "Battle of the Bots VRC Signature Event",
        location: "Bristol TN",
        date: "Febuary 9-10th, 2024 - Bristol TN",
        imgKey: "f",
        description: "Awards:",
        award1: "   - Robot Skills Champion (2055A)",
        award2: "   - Think Award (2055A)"
    },
    {
        title: "iDESIGN Central Toronto VEX VRC Robotics Competition",
        location: "Toronto ON",
        date: "Febuary 10th, 2024 - Toronto ON",
        imgKey: "d",
        description: "Awards:",
        award1: "   - Build Award (2055X)",
        award2: "   - Tournament Champions (2055X)"
    },
    {
        title: "Ontario VRC Over/Under Provincial Championships",
        location: "Markham ON",
        date: "Febuary 23-24th, 2024 - Markham ON",
        imgKey: "c",
        description: "Awards:",
        award1: "   - Tournament Champions (2055X)"
    },
    {
        title: "2024 VEX Robotics World Championship",
        location: "Dallas TX",
        date: "April 25-27th, 2024 - Dallas TX",
        imgKey: "b",
        description: "Awards:",
        award1: "   - Create Award (2055A)"
    },
    {
        title: "VEX AI World Championship",
        location: "Houston TX",
        date: "June 7-8th, 2024 - Houston TX",
        imgKey: "e",
        description: "Awards:",
        award1: "   - Robot Skills Champion (2055A)",
        award2: "   - Innovate Award (2055A)"
    },
    {
        title: "Highlander Summit VEX V5 Signature Event",
        location: "Houston TX",
        date: "September 20-22nd, 2024 - Newark NJ",
        imgKey: "i",
        description: "Awards:",
        award1: "   - Think Award (2055A)",
    },
    {
        title: "Glenforest iDESIGN 365 VEX V5 Robotics Competition",
        location: "Missisauga ON",
        date: "November 23, 2024 - Missisauga ON",
        imgKey: "j",
        description: "Awards:",
        award1: "   - Design Award (2055A)",
    },
    {
        title: "St. Catharines VEX V5 Robotics Competition Qualifier",
        location: "Missisauga ON",
        date: "December 7, 2024 - St. Catharines ON",
        imgKey: "k",
        description: "Awards:",
        award1: "   - Innovate Award (2055X)",
    },
    {
        title: "The RiverBots III VEX V5 Robotics Competition Signature Event",
        location: "Missisauga ON",
        date: "December 13-14th & 15-16th, 2024 - Monroe MI",
        imgKey: "l",
        description: "Awards:",
        award1: "   - Design Award (2055X)",
        award2: "   - Think Award (2055A)"
    },
    {
        title: "Gateway to the West VEX V5 Robotics Competition Signature Event",
        location: "Missisauga ON",
        date: "January 29-30th, 2025 - Triadelphia WV",
        imgKey: "m",
        description: "Awards:",
        award1: "   - Judges Award (2055X)",
    },
    {
        title: "VEX Robotics World Championship",
        location: "Missisauga ON",
        date: "May 9-11th, 2025 - Dallas TX",
        imgKey: "n",
        description: "Awards:",
        award1: "   - Design Award (2055X)",
    },
]
items.reverse()
export {items, imageMap}